import { render, staticRenderFns } from "./orderMain.vue?vue&type=template&id=1ec678d8&scoped=true&"
import script from "./orderMain.vue?vue&type=script&lang=js&"
export * from "./orderMain.vue?vue&type=script&lang=js&"
import style0 from "./orderMain.vue?vue&type=style&index=0&id=1ec678d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec678d8",
  null
  
)

export default component.exports